import api from "./api"
import { sentryService } from "./sentry"

/**
 * Maps a phone auth request's failure to a user-facing message. 429 (rate
 * limited) and 503 (Twilio unavailable) must read differently from a wrong
 * code, or a throttled/outage user is told their input was bad instead of
 * being told to wait or retry.
 */
export const phoneErrorMessage = (error, field, fallback) => {
  const status = error.response?.status

  if (status === 429) {
    return "Too many attempts. Please wait a moment and try again."
  }

  if (status === 503) {
    return (
      error.response?.data?.message ||
      "Phone verification is currently unavailable. Please try again later."
    )
  }

  if (status === 422) {
    return error.response?.data?.errors?.[field]?.[0] || fallback
  }

  return "Something went wrong. Please try again."
}

export const auth = {
  logout: () =>
    api.logout().then(() => {
      sentryService.setUserContext(null)
      // Clear the last viewed plan token
      localStorage.removeItem('encircled_last_plan_token')
      const bc = new BroadcastChannel("auth")
      bc.postMessage({ type: "logged_out" })
      bc.close()
      window.location.reload()
    }),
}
